/** ローカル実ファイルの読み取り専用の版確認。アカウント・端末名・認証情報を扱わない。 */
export const LOCAL_MCP_STATUS_PORT = 43827;
export const LOCAL_MCP_STATUS_PATH = '/acecollect/mcp-status';
export const LOCAL_MCP_STATUS_URL = 'http://127.0.0.1:43827/acecollect/mcp-status';
export const LOCAL_MCP_STATUS_SCHEMA = 1;
export const LOCAL_MCP_STATUS_APP = 'acecollect-local-mcp';
export const LOCAL_MCP_STATUS_NONCE = /^[A-Za-z0-9_-]{43}(?![\s\S])/;
export const LOCAL_MCP_VERSION =
  /^(?:0|[1-9]\d{0,3})\.(?:0|[1-9]\d{0,3})\.(?:0|[1-9]\d{0,5})(?![\s\S])/;

/** nonceはキャッシュの再利用を防ぐ。補助表示専用であり、認証やアクセス制御には使わない。 */
export function parseLocalMcpStatus(value: unknown, nonce: string): { version: string } | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const record = value as Record<string, unknown>;
  if (
    !LOCAL_MCP_STATUS_NONCE.test(nonce) ||
    record.schemaVersion !== LOCAL_MCP_STATUS_SCHEMA ||
    record.app !== LOCAL_MCP_STATUS_APP ||
    record.nonce !== nonce ||
    typeof record.version !== 'string' ||
    !LOCAL_MCP_VERSION.test(record.version) ||
    Object.keys(record).some((key) => !['schemaVersion', 'app', 'nonce', 'version'].includes(key))
  )
    return null;
  return { version: record.version };
}
